import { render, staticRenderFns } from "./RedditoModal.vue?vue&type=template&id=707e68ce&scoped=true&"
import script from "./RedditoModal.vue?vue&type=script&lang=js&"
export * from "./RedditoModal.vue?vue&type=script&lang=js&"
import style0 from "./RedditoModal.vue?vue&type=style&index=0&id=707e68ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e68ce",
  null
  
)

component.options.__file = "RedditoModal.vue"
export default component.exports